import { render } from "./NavButton.vue?vue&type=template&id=c189077e&scoped=true&ts=true"
import script from "./NavButton.vue?vue&type=script&lang=ts"
export * from "./NavButton.vue?vue&type=script&lang=ts"

import "./NavButton.vue?vue&type=style&index=0&id=c189077e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c189077e"]])

export default __exports__